module.exports = __webpack_public_path__ + "img/credit-card-search.60812cfd.svg";